import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import img from '../../../assets/Img';



const translations = {
    en: require("../../../Translate/en.json").WhyChooseRightClick,
    ar: require("../../../Translate/ar.json").WhyChooseRightClick,
};
const WhyChooseRightClick = () => {
    const { i18n } = useTranslation();
    const isLang = i18n.language;
    const tData = translations[isLang || 'en'];

    const t = (keyPath) => keyPath.split('.').reduce((obj, key) => obj?.[key], tData) || '';

    return (
        <>
            <div className="why-choose-section pt flex flex-column justify-content-center align-items-center">
                {/* Section 1: Title & Description */}
                <div className="content flex flex-column justify-content-center align-items-center">
                    <h2>{t('title')}</h2>
                    <p>{t('description')}</p>
                </div>

                {/* Section 2: Image */}
                <div className="visual">
                    <div className="image-container">
                        <img
                            src={img.seoBG}
                            alt="Right Click"
                            className="img_right_click"
                            width="100%"
                            style={{ maxHeight: '600px', objectFit: 'cover' }}
                        />
                    </div>
                </div>
            </div>

            {/* Section 3: Benefits */}
            <div className="py-8 section_">
                <div className={`benefits-section ${isLang == "en" ? "ltr" : "rtl"}`}>

                    <h3>{t('benefitsTitle')}</h3>
                    <ul>
                        {['benefit1', 'benefit2', 'benefit3', 'benefit4'].map((key, index) => (
                            <li key={index}>
                                <b>{t(`${key}.title`)}</b> {t(`${key}.description`)}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default WhyChooseRightClick;
